PresentersBase =
  getI18n: (I18nScope)->
    scope = I18nScope
    if scope?
      I18n.scoped scope
    else
      I18n

  toHashWithHelpers: (hash, I18nScope)->
    presenterHash = _.clone hash
    I18n.mixin(presenterHash, @getI18n(I18nScope))

module.exports = PresentersBase
